import React from 'react';

const partnerHighlights = [
  {
    title: 'Coordinated Orders',
    description: 'We call your store with clear requirements and share confirmed orders so you can prepare without confusion.',
  },
  {
    title: 'Invoice Transparency',
    description: 'Customers receive your printed bill with every delivery, building trust and repeat demand for your shop.',
  },
  {
    title: 'Dedicated Support',
    description: 'Our operations desk keeps you updated on pickups, returns, and customer feedback in real time.',
  },
];

const PartnersSection = () => {
  return (
    <section className="relative overflow-hidden bg-slate-900 py-24 text-white">
      <div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-emerald-500/40 to-transparent" />
      <div className="mx-auto flex max-w-6xl flex-col gap-16 px-6 lg:flex-row lg:items-center">
        <div className="flex-1 space-y-6">
          <span className="inline-flex items-center rounded-full bg-white/10 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-emerald-200">
            Partners
          </span>
          <h2 className="text-3xl font-bold sm:text-4xl">Grow with Dial TPR&apos;s call-first network</h2>
          <p className="text-base text-slate-200">
            We work closely with retailers who value personal relationships with customers. Our team manages the entire order cycle, keeping you free to focus on great service while we handle communication and last-mile delivery.
          </p>
          <div className="grid gap-6 sm:grid-cols-3">
            {partnerHighlights.map((item) => (
              <div key={item.title} className="rounded-3xl border border-white/10 bg-white/5 p-6 backdrop-blur">
                <h3 className="text-lg font-semibold text-white">{item.title}</h3>
                <p className="mt-2 text-sm text-slate-200/90">{item.description}</p>
              </div>
            ))}
          </div>
          <div className="flex flex-wrap gap-3 pt-4">
            <a
              href="tel:+919176126422"
              className="inline-flex items-center rounded-full bg-emerald-400 px-6 py-3 text-sm font-semibold text-slate-900 shadow-lg shadow-emerald-600/30 transition hover:-translate-y-0.5 hover:bg-emerald-300"
            >
              Call the Partnerships Desk
            </a>
            <a
              href="mailto:dailtpr@gmail.com"
              className="inline-flex items-center rounded-full border border-white/40 px-6 py-3 text-sm font-semibold text-white transition hover:bg-white/10"
            >
              Write to us
            </a>
          </div>
        </div>
        <div className="flex-1">
          <div className="relative mx-auto max-w-md rounded-3xl border border-white/10 bg-white/5 p-8 text-left shadow-2xl shadow-emerald-600/30 backdrop-blur">
            <p className="text-sm uppercase tracking-[0.3em] text-emerald-200">Partner Snapshot</p>
            <div className="mt-6 space-y-4 text-slate-100">
              <div>
                <p className="text-4xl font-bold text-white">95%</p>
                <p className="text-xs uppercase tracking-wide text-slate-300">Orders delivered with invoice copy</p>
              </div>
              <div className="h-px bg-white/10" />
              <div>
                <p className="text-4xl font-bold text-white">20+</p>
                <p className="text-xs uppercase tracking-wide text-slate-300">Neighbourhood shops supported daily</p>
              </div>
              <div className="h-px bg-white/10" />
              <div>
                <p className="text-4xl font-bold text-white">24/7</p>
                <p className="text-xs uppercase tracking-wide text-slate-300">Ops desk for urgent requirements</p>
              </div>
            </div>
            <p className="mt-6 text-sm text-slate-200">
              Our partner success desk keeps every store updated on pickups, billing status, and customer feedback so you can focus entirely on in-store service.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
